<template>
  <Card class="mt-2">
    <template #title> Settings </template>
    <template #content>
      <div class="grid">
        <div class="field col-12 md:col-6 lg:col-4">
          <div>{{ required ? 'Required' : 'Not Required' }}</div>
          <InputSwitch v-model="required" />
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
          <div class="flex p-float-label">
            <Dropdown
              v-model="country"
              :options="countries"
              optionLabel="title"
              optionValue="value"
              showClear
              inputId="country"
              class="flex-grow-1"
            ></Dropdown>
            <label for="country">Country</label>
          </div>
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
          <div class="flex p-float-label">
            <Dropdown
              v-model="defaultType"
              :options="identification_type_options"
              optionLabel="title"
              showClear
              inputId="default_id_type"
              class="flex-grow-1"
            ></Dropdown>
            <label for="default_id_type">Default ID Type</label>
          </div>
        </div>

        <div class="field col-12 md:col-6 lg:col-4">
          <div>{{ selectable ? 'User selectable ID type' : 'Do not show the ID type' }}</div>
          <InputSwitch v-model="selectable" />
        </div>
        <div class="field col-12 md:col-6 lg:col-4">
          <div>{{ none ? "Include 'none provided' as an option" : 'Allow \`none provided\`' }}</div>
          <InputSwitch v-model="none" />
        </div>
        <div class="field col-12">
          <div class="flex p-float-label">
            <MultiSelect
              v-model="identification_type"
              display="chip"
              :options="identification_type_options"
              optionLabel="title"
              inputId="id_types"
              class="flex-grow-1"
              :maxSelectedLabels="2"
            />
            <label for="id_types">ID Types</label>
          </div>
        </div>
      </div>
    </template>
  </Card>

  <Divider />
  <Card>
    <template #title> Component </template>
    <template #content>
      <form @submit.prevent="submitForm">
        <IdentityNumber
          v-model="id_number"
          label="Identity Number"
          :selectable="selectable"
          :defaultType="defaultType"
          :identityTypeList="identification_types"
          :country_code="country"
        ></IdentityNumber>
        <Button type="submit" label="Submit"></Button>
      </form>
    </template>
  </Card>
  <Card>
    <template #title> Output </template>
    <template #content> {{ id_number }} </template>
  </Card>
</template>
<script setup>
import { ref, computed } from 'vue'
import IdentityNumber from '@/components/input/IdentityNumber.vue'
import useValidate from '@vuelidate/core'
const id_number = ref(null)
const country = ref(null)
const required = ref(true)
const identification_type = ref(null)
const none = ref(true)
const selectable = ref(true)
const defaultType = ref('national_id')

const identification_types = computed(() => {
  let r = [
    { value: 'voters_card', title: 'Voters Card' },
    { value: 'national_id', title: 'National ID' },
    { value: 'drivers_license', title: 'Drivers License' },
    { value: 'passport', title: 'Passport' }
  ]
  if (country.value === 'CO') {
    r = [
      { value: 'national_id', title: 'National ID' },
      { value: 'foreigner_id', title: 'Foreigner ID' },
      { value: 'passport', title: 'Passport' }
    ]
  }
  if (country.value === 'ZA') {
    r = [
      { value: 'national_id', title: 'National ID' },
      { value: 'passport', title: 'Passport' }
    ]
  }
  if (none.value) {
    r.unshift({ value: 'none', title: 'None' })
  }
  return r
})

const countries = [
  { title: 'Botswana', value: 'BW' },
  { title: 'South Africa', value: 'ZA' }
]

const identification_type_options = [
  { value: 'voters_card', title: 'Voters Card' },
  { value: 'national_id', title: 'National ID' },
  { value: 'drivers_license', title: 'Drivers License' },
  { value: 'passport', title: 'Passport' },
  { value: 'foreigner_id', title: 'Foreigner ID' }
]

const v = useValidate()
const submitForm = async () => {
  const result = await v.value.$validate()
  if (result) {
    alert('success')
  } else {
    alert('error')
  }
}
</script>
